module.exports = __webpack_public_path__ + "img/ic_delete.aaef4e9f.svg";